import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import LandingPage from './pages/LandingPage';
import Specifications from './pages/Specifications';
import MaterialsExtended from './pages/MaterialsExtended';
import FeaturesExtended from './pages/FeaturesExtended';
import Downloads from './pages/Downloads';
import Products from './pages/Products';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/specifications" element={<Specifications />} />
          <Route path="/materials" element={<MaterialsExtended />} />
          <Route path="/features" element={<FeaturesExtended />} />
          <Route path="/downloads" element={<Downloads />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;